enum UiUrlParams {
  releaseOrDraftProcessId = 'releaseOrDraftProcessId',
  draftProcessId = 'draftProcessId',
  source = 'source',
  token = 'token',
  groupId = 'groupId',
  ott = 'ott',
  ftpPollingScenarioId = 'ftpPollingScenarioId',
  processVersionId = 'processVersionId',
  processInstanceId = 'processInstanceId',
  stepId = 'stepId',
  formId = 'formId',
  fieldId = 'fieldId',
  ftpConnectionId = 'ftpConnectionId',
  outboundEmailConnectionId = 'outboundEmailConnectionId',
  splitDocInstanceId = 'splitDocInstanceId',
  emailTemplateId = 'emailTemplateId',
  printRenderScenarioId = 'printRenderScenarioId',
  printRenderInstanceId = 'printRenderInstanceId',
  scanInstanceId = 'scanInstanceId',
  scanConfigurationId = 'scanConfigurationId',
  oidcProvider = 'oidcProvider',
  taskId = 'taskId',
  automatedIndexingScenarioId = 'automatedIndexingScenarioId',
}

export default UiUrlParams;
